module.exports = "/images/hmong.svg?108118e02e157f6b302bc45aec41a56b";